module.exports = __webpack_public_path__ + "img/player-bag.c0fdf4de.png";